// extracted by mini-css-extract-plugin
export default {"carousel-modal":"styles__carousel-modal--iBLly"};